import { Component, OnInit, Input } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
//import { Color, Label } from '@rinminase/ng-charts';
import { TestResultService } from '../../services/test-result.service';
//import { ResultCumulative } from '../../models/ResultCumulative';
import { CumulativeQuery } from '../../models/CumulativeQuery';

@Component({
  selector: 'result-cumulative',
  templateUrl: './result-cumulative.component.html',
  styleUrls: ['./result-cumulative.component.css']
})

export class CumulativeComponent implements OnInit {
  private _cumulativeQuery: CumulativeQuery;
  private colours: string[] = [
    'rgba(0, 0, 0, 0.7)',
    'rgba(255, 0, 0, 0.7)',
    'rgba(0, 255, 0, 0.7)',
    'rgba(0, 0, 255, 0.7)',
    'rgba(255, 255, 0, 0.7)',
    'rgba(0, 255, 255, 0.7)',
    'rgba(255, 0, 255, 0.7)'
  ]
  @Input() set cumulativeQuery(cumulativeQuery: CumulativeQuery) {
    this._cumulativeQuery = cumulativeQuery;
    this.setData();
  }

  @Input() set shouldBeEmpty(shouldBeEmpty: boolean) {
    if (shouldBeEmpty) this.lineChartData = [{
      type: 'line',
      pointRadius: 5,
      hideInLegendAndTooltip: true,
      fill: false,
      lineTension: 0,
      borderWidth: 2,
      data: [],
    }];
  }

  public fromDate = new Date(2020, 1, 1).toShortDateString(); // 1 month ago.
  public toDate = new Date().toShortDateString();
  public testCodes: string[] = [];
  public lineChartData: ChartDataSets[] = [{  type: 'line',
    pointRadius: 5,
    hideInLegendAndTooltip: true,
    fill: false,
    lineTension: 0,
    borderWidth: 2,
    data: [],
  }];
  public lineChartType = 'line';
  public lineChartOptions: (ChartOptions);

  constructor(private testResultSevice: TestResultService) { }

  ngOnInit() {
    this.setData();
    this.lineChartOptions = {
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          type: 'time',
          distribution: 'series',
          offset: true,
          ticks: {
            major: {
              enabled: true,
              fontStyle: 'bold'
            },
            source: 'data',
            autoSkip: true,
            autoSkipPadding: 75,
            maxRotation: 0,
            sampleSize: 5
          }
        }],
        yAxes: [{
          ticks: {
            display: true,
          }
        }]
      }
    };
  }

  dateChanged(evt: any) {
    this.lineChartData = [ { data: [] } ];
    this.setData();
  }

  setData() {
    console.log(this.lineChartData[0].data);
    if (this.testCodes.findIndex(testCode => testCode === this._cumulativeQuery.testCode) < 0) { this.testCodes.push(this._cumulativeQuery.testCode) }
    this.testCodes.forEach(testCode => {
      const srchCrits = { testCode: testCode, surname: this._cumulativeQuery.surname, forename: this._cumulativeQuery.forename, dob: this._cumulativeQuery.dob, fromDate: this.fromDate, toDate: this.toDate }
      this.testResultSevice.getTestResultsCumulative(srchCrits).subscribe(resultList => {
        if (this.lineChartData[0].data.length === 0) { //
          console.log('blatting data');
          this.lineChartData = [{
            label: this._cumulativeQuery.testCode,
            type: 'line',
            borderColor: this.colours[(this.lineChartData.length - 1) % (this.colours.length)],
            backgroundColor: this.colours[(this.lineChartData.length - 1) % (this.colours.length)],
            pointRadius: 5,
            fill: false,
            lineTension: 0,
            borderWidth: 2,
            data: resultList
          }]
        }
        else {
          if (this.lineChartData.findIndex(chartData => chartData.label === testCode) < 0) {
            console.log('pushing ', this._cumulativeQuery.testCode);
            this.lineChartData.push(
              {
                label: this._cumulativeQuery.testCode,
                type: 'line',
                borderColor: this.colours[(this.lineChartData.length) % (this.colours.length)],
                backgroundColor: this.colours[(this.lineChartData.length) % (this.colours.length)],
                pointRadius: 5,
                fill: false,
                lineTension: 0,
                borderWidth: 2,
                data: resultList
              }
            )
          }
          else { console.log("not adding ", this._cumulativeQuery.testCode); }
        }
      })
    })
  }
}
